import devConfig from "./development";

const env = process.env.REACT_APP_STAGE || "dev";

const configs = {
  dev: devConfig
};

export default configs[env];
